import { create } from 'zustand'

interface AdminUiState {
  mobileNavOpen: boolean
  openMobileNav: () => void
  closeMobileNav: () => void
  toggleMobileNav: () => void
}

export const useAdminUiStore = create<AdminUiState>((set, get) => ({
  mobileNavOpen: false,
  openMobileNav: () => set({ mobileNavOpen: true }),
  closeMobileNav: () => set({ mobileNavOpen: false }),
  toggleMobileNav: () => set({ mobileNavOpen: !get().mobileNavOpen }),
}))
